<template>
  <div class="Home padding">

    <h1>
      Textify privacy
    </h1>

    <div class="columns">

      <div class="shadowedBox">

        <h2>Public rooms</h2>
        <p>
          All rooms are publically open for anyone with the right link to join.
        </p>
        <p>
          If you name your room to something popular, you might get unexpected visitors wanting to use the same room name.
        </p>
        <p>
          Therefor, always use room names that are hard to guess.
        </p>
      </div>

      <div class="shadowedBox">
        <h2>Speech recognition</h2>
        <p>
          Textify uses the open standard <a href="https://developer.mozilla.org/en-US/docs/Web/API/Web_Speech_API" target="_blank">Web Speech API</a>.
        </p>
        <p>
          Depending on the browser and system you are using different features are available. Your voice data can be sent to third party web services to handle the speech recognition.
        </p>
      </div>

      <div class="shadowedBox">
        <h2>Data privacy</h2>
        <p>
          Textify does not store nor analyze the content of your speech and conversations for any purposes.
        </p>
        <p>
          Depending on your browser and system Textify can't guarantee that third party services that handle the actual speech recognition won't analyze the data. This applies to any web application using Web Speech API - not just Textify.
        </p>
      </div>

    </div>

  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Integrity',
  components: {
  },
  data: function () {
    return {
    }
  },
  methods: {
  },
  mounted: function () {
  }
}
</script>

<style lang="scss" scoped>

  .columns{
    flex-wrap: wrap;
  }

  .columns > div{
    flex: 1;
    background: var(--color1);
    padding: 10px;
    //border: var(--border);
    box-shadow: 5px 5px 0 var(--color0);
    margin: 5px;
  }

</style>
